var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimintroPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#386937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84637 10.8599L6.24492 9.25847C5.92822 8.94177 5.92822 8.42831 6.24492 8.11162L7.40418 6.95235C8.06702 6.28951 9.1013 6.17598 9.89214 6.67924L10.7413 7.21963C13.445 8.94015 15.7381 11.2332 17.4586 13.9369L17.999 14.7861C18.5022 15.5769 18.3887 16.6112 17.7259 17.274L16.5666 18.4333C16.2499 18.75 15.7364 18.75 15.4197 18.4333L13.8183 16.8318C13.7527 16.7662 13.7527 16.6598 13.8183 16.5942L14.3488 16.0636C14.6633 15.7492 14.8177 15.3089 14.7686 14.8669C14.4788 12.2585 12.4197 10.1994 9.81129 9.90959C9.36933 9.86048 8.929 10.0149 8.61457 10.3294L8.08403 10.8599C8.0184 10.9255 7.91199 10.9255 7.84637 10.8599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.62189
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimintroPhone);
export default __webpack_public_path__ + "static/media/claimintroPhone.9a95a19c9c99b3b3968e647d1daf63cf.svg";
export { ForwardRef as ReactComponent };